import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, command, keyBinding, NamedShortcut, MarkExtension, ExtensionTag, toggleMark } from '@remirror/core';
import { ExtensionSubMessages } from '@remirror/messages';

var _dec, _dec2, _dec3, _class, _class2;
var toggleSubscriptOptions = {
  icon: 'subscript',
  label: _ref => {
    var t = _ref.t;
    return t(ExtensionSubMessages.LABEL);
  }
};
var SubExtension = (_dec = extension({}), _dec2 = command(toggleSubscriptOptions), _dec3 = keyBinding({
  shortcut: NamedShortcut.Subscript,
  command: 'toggleSubscript'
}), _dec(_class = (_class2 = class SubExtension extends MarkExtension {
  get name() {
    return 'sub';
  }

  createTags() {
    return [ExtensionTag.FormattingMark, ExtensionTag.FontStyle];
  }

  createMarkSpec(extra) {
    return {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'sub',
        getAttrs: extra.parse
      }],
      toDOM: mark => ['sub', extra.dom(mark), 0]
    };
  }
  /**
   * Toggle the subscript formatting of the selected text.
   */


  toggleSubscript() {
    return toggleMark({
      type: this.type
    });
  }
  /**
   * Attach the keyboard shortcut for making text bold to this mark and also to
   * the `toggleBold` command.
   */


  shortcut(props) {
    return this.toggleSubscript()(props);
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "toggleSubscript", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleSubscript"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shortcut", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "shortcut"), _class2.prototype)), _class2)) || _class);

export { SubExtension };
